// extracted by mini-css-extract-plugin
module.exports = {"container":"_3yUB7XqlAo89","type_review":"_2JWBMcWDYxIu"};